import gql from 'graphql-tag';
import { clients } from '../../util/clients';

const { backend } = clients.direct;
const firstIndex = 0;

const ODDepositEnumElements = {
  cashCheckReconciliation: { name: 'CASHCHECK', description: 'Cash and/or Check' },
  ccReconciliation: { name: 'CREDIT', description: 'Credit' },
  trustReconciliation: { name: 'TRUST', description: 'Trust' },
};

const addItemInArray = (array, item) => {
  const arrayObj = [...array];
  const index = arrayObj.findIndex((x) => x.name === item.name);
  if (index === -1) {
    arrayObj.push(item);
  }
  return arrayObj;
};

const removeItemFromArray = (array, item) => {
  const arrayObj = [...array];
  const index = arrayObj.findIndex((x) => x.name === item.name);
  if (index > -1) {
    arrayObj.splice(index, 1);
  }
  return arrayObj;
};

export const enums = {
  namespaced: true,
  state: () => ({
    ODTransType: undefined,
    ODDepositEnum: undefined,
    ODCardItemTypeEnum: undefined,
    ODEFTItemTypeEnum: undefined,
    ODStatus: undefined,
    ODTrustPaymentTypeEnum: undefined,
    WarGovFunctionEnum: undefined,
    WarTransTypeEnum: undefined,
    WarTransStatusEnum: undefined,
    fundReconTypeEnum: undefined,
    cmnSourceTypeEnum: undefined,
    MISCPaymentTypeEnum: undefined,
    MISCEFTTypeEnum: undefined,
    MISCCardTypeEnum: undefined,
    mtgPaymentTypeEnum: undefined,
    mtgEFTTypeEnum: undefined,
    mtgCCardTypeEnum: undefined,
    sharedBackPageEnum: undefined,
    TaxUnitDetailSDRTypeEnum: undefined,
    GlTransDailySectionEnum: undefined,
    GlInvestmentTypeEnum: undefined,
    GlEntryPrincipleOrIntrestTypeEnum: undefined,
    GlTransTagEnum: undefined,
    GlReportHeadingsTotalsTypeEnum: undefined,
    SaiMonthlyTransactionSectionEnum: undefined,
    SaiBankReconAddDeductEnum: undefined,
    TaxRollAdjustUpdateEnum: undefined,
    taxCommentTypesStatusEnum: undefined,
    TaxPaymentEnum: undefined,
    TaxCCPaymentTypeEnum: undefined,
    TaxCCSpecialPaymentTypeEnum: undefined,
    TaxCCPaymentStatusEnum: undefined,
    TaxCCPaymentInstallmentEnum: undefined,
    TaxCCModeOfPaymentEnum: undefined,
    TaxTypeEnum: undefined,
    TaxPaymentTypeEnum: undefined,
    ApportionmentRecordTypeEnum: undefined,
    TaxPaymentModesEnum: undefined,
  }),
  mutations: {
    setEnums(state, results) {
      state.ODTransType = results.data.ODTransType.enumValues;
      state.ODDepositEnum = results.data.ODDepositEnum.enumValues;
      state.ODCardItemTypeEnum = results.data.ODCardItemTypeEnum.enumValues;
      state.ODEFTItemTypeEnum = results.data.ODEFTItemTypeEnum.enumValues;
      state.ODStatus = results.data.ODStatus.enumValues;
      state.ODTrustPaymentTypeEnum = results.data.ODTrustPaymentTypeEnum.enumValues;
      state.WarGovFunctionEnum = results.data.WarGovFunctionEnum.enumValues;
      state.WarTransTypeEnum = results.data.WarTransTypeEnum.enumValues;
      state.WarTransStatusEnum = results.data.WarTransStatusEnum.enumValues;
      state.SharedFundTypeEnum = results.data.CmnFundTypeEnum.enumValues;
      state.TaxTypeEnum = results.data.TaxTypeEnum.enumValues;
      state.fundReconTypeEnum = results.data.fundReconTypeEnum.enumValues;
      state.cmnSourceTypeEnum = results.data.cmnSourceTypeEnum.enumValues;
      state.MISCPaymentTypeEnum = results.data.MISCPaymentTypeEnum.enumValues;
      state.MISCEFTTypeEnum = results.data.MISCEFTTypeEnum.enumValues;
      state.MISCCardTypeEnum = results.data.MISCCardTypeEnum.enumValues;
      state.mtgPaymentTypeEnum = results.data.mtgPaymentTypeEnum.enumValues;
      state.mtgEFTTypeEnum = results.data.mtgEFTTypeEnum.enumValues;
      state.mtgCCardTypeEnum = results.data.mtgCCardTypeEnum.enumValues;
      state.sharedBackPageEnum = results.data.sharedBackPageEnum.enumValues;
      state.TaxUnitDetailSDRTypeEnum = results.data.TaxUnitDetailSDRTypeEnum.enumValues;
      state.GlTransDailySectionEnum = results.data.GlTransDailySectionEnum.enumValues;
      state.GlInvestmentTypeEnum = results.data.GlInvestmentTypeEnum.enumValues;
      state.GlEntryPrincipleOrIntrestTypeEnum = results.data
        .GlEntryPrincipleOrIntrestTypeEnum.enumValues;
      state.GlTransTagEnum = results.data.GlTransTagEnum.enumValues;
      state.GlReportHeadingsTotalsTypeEnum = results.data.GlReportHeadingsTotalsTypeEnum.enumValues;
      state.SaiMonthlyTransactionSectionEnum = results.data.SaiMonthlyTransactionSectionEnum
        .enumValues;
      state.SaiBankReconAddDeductEnum = results.data.SaiBankReconAddDeductEnum.enumValues;
      state.TaxRollAdjustUpdateEnum = results.data.TaxRollAdjustUpdateEnum.enumValues;
      state.taxCommentTypesStatusEnum = results.data.taxCommentTypesStatusEnum.enumValues;
      state.TaxPaymentEnum = results.data.TaxPaymentEnum.enumValues;
      state.TaxCCPaymentTypeEnum = results.data.TaxCCPaymentTypeEnum.enumValues;
      state.TaxCCSpecialPaymentTypeEnum = results.data.TaxCCSpecialPaymentTypeEnum.enumValues;
      state.TaxCCPaymentStatusEnum = results.data.TaxCCPaymentStatusEnum.enumValues;
      state.TaxCCPaymentInstallmentEnum = results.data.TaxCCPaymentInstallmentEnum.enumValues;
      state.TaxCCModeOfPaymentEnum = (results.data.TaxCCModeOfPaymentEnum || {}).enumValues;
      state.TaxPaymentTypeEnum = results.data.TaxPaymentTypeEnum.enumValues;
      state.ApportionmentRecordTypeEnum = results.data.ApportionmentRecordTypeEnum.enumValues;
      state.TaxPaymentModesEnum = results.data.TaxPaymentModesEnum.enumValues;
    },
    setODDepositEnum(state, config) {
      let configuration;
      let item;
      let result;
      if (config[firstIndex] !== undefined) {
        configuration = config[firstIndex].configuration;
        Object.keys(ODDepositEnumElements).forEach((element) => {
          item = configuration[`${element}`];
          if (item) {
            result = addItemInArray(state.ODDepositEnum, ODDepositEnumElements[element]);
          } else {
            result = removeItemFromArray(state.ODDepositEnum, ODDepositEnumElements[element]);
          }
          state.ODDepositEnum = result;
        });
      }
    },
  },
  actions: {
    async cacheEnums({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            ODTransType:__type(name:"ODTransType") {
              enumValues {
                name, description
              }
            },
            ODDepositEnum:__type(name:"ODDepositEnum") {
              enumValues {
                name, description
              }
            },
            ODCardItemTypeEnum:__type(name:"ODCardItemTypeEnum") {
              enumValues {
                name, description
              }
            },
            ODEFTItemTypeEnum:__type(name:"ODEFTItemTypeEnum") {
              enumValues {
                name, description
              }
            },
            ODStatus:__type(name:"ODStatus") {
              enumValues {
                name, description
              }
            },
            ODTrustPaymentTypeEnum:__type(name:"ODTrustPaymentTypeEnum") {
              enumValues {
                name, description
              }
            },
            WarGovFunctionEnum:__type(name:"WarGovFunctionEnum") {
              enumValues {
                name, description
              }
            },
            WarTransTypeEnum:__type(name:"WarTransTypeEnum") {
              enumValues {
                name, description
              }
            },
            WarTransStatusEnum:__type(name:"WarTransStatusEnum") {
              enumValues {
                name, description
              }
            },
            CmnFundTypeEnum:__type(name:"CmnFundTypeEnum") {
              enumValues {
                name, description
              }
            },
            fundReconTypeEnum:__type(name:"fundReconTypeEnum") {
              enumValues {
                name, description
              }
            },
            cmnSourceTypeEnum:__type(name:"cmnSourceTypeEnum") {
              enumValues {
                name, description
              }
            },
            MISCPaymentTypeEnum:__type(name:"MISCPaymentTypeEnum") {
              enumValues {
                name, description
              }
            },
            MISCEFTTypeEnum:__type(name:"MISCEFTTypeEnum") {
              enumValues {
                name, description
              }
            },
            MISCCardTypeEnum:__type(name:"MISCCardTypeEnum") {
              enumValues {
                name, description
              }
            },
            mtgPaymentTypeEnum:__type(name:"mtgPaymentTypeEnum") {
              enumValues {
                name, description
              }
            },
            mtgEFTTypeEnum:__type(name:"mtgEFTTypeEnum") {
              enumValues {
                name, description
              }
            },
            mtgCCardTypeEnum:__type(name:"mtgCCardTypeEnum") {
              enumValues {
                name, description
              }
            },
            sharedBackPageEnum:__type(name:"sharedBackPageEnum") {
              enumValues {
                name, description
              }
            },
            TaxUnitDetailSDRTypeEnum:__type(name:"TaxUnitDetailSDRTypeEnum") {
              enumValues {
                name, description
              }
            },
            GlTransDailySectionEnum:__type(name:"GlTransDailySectionEnum") {
              enumValues {
                name, description
              }
            },
            GlInvestmentTypeEnum:__type(name:"GlInvestmentTypeEnum") {
              enumValues {
                name, description
              }
            },
            GlEntryPrincipleOrIntrestTypeEnum:__type(name:"GlEntryPrincipleOrIntrestTypeEnum") {
              enumValues {
                name, description
              }
            },
            GlTransTagEnum:__type(name:"GlTransTagEnum") {
              enumValues {
                name, description
              }
            },
            GlReportHeadingsTotalsTypeEnum:__type(name:"GlReportHeadingsTotalsTypeEnum") {
              enumValues {
                name, description
              }
            },
            SaiMonthlyTransactionSectionEnum:__type(name:"SaiMonthlyTransactionSectionEnum") {
              enumValues {
                name, description
              }
            },
            SaiBankReconAddDeductEnum:__type(name:"SaiBankReconAddDeductEnum") {
              enumValues {
                name, description
              }
            },
            TaxRollAdjustUpdateEnum:__type(name:"TaxRollAdjustUpdateEnum") {
              enumValues {
                name, description
              }
            },
            taxCommentTypesStatusEnum:__type(name:"taxCommentTypesStatusEnum") {
              enumValues {
                name, description
              }
            },
            TaxPaymentEnum:__type(name:"TaxPaymentEnum") {
              enumValues {
                name, description
              }
            },
            TaxCCPaymentTypeEnum:__type(name:"TaxCCPaymentTypeEnum") {
              enumValues {
                name, description
              }
            },
            TaxCCSpecialPaymentTypeEnum:__type(name:"TaxCCSpecialPaymentTypeEnum") {
              enumValues {
                name, description
              }
            },
            TaxCCPaymentStatusEnum:__type(name:"TaxCCPaymentStatusEnum") {
              enumValues {
                name, description
              }
            },
            TaxCCPaymentInstallmentEnum:__type(name:"TaxCCPaymentInstallmentEnum") {
              enumValues {
                name, description
              }
            },
            TaxCCModeOfPaymentEnum:__type(name:"TaxCCModeOfPaymentEnum") {
              enumValues {
                name, description
              }
            },
            TaxTypeEnum:__type(name:"TaxTypeEnum") {
              enumValues {
                name, description
              }
            },
            TaxPaymentTypeEnum:__type(name:"TaxPaymentTypeEnum") {
              enumValues {
                name, description
              }
            },
            ApportionmentRecordTypeEnum:__type(name:"ApportionmentRecordTypeEnum") {
              enumValues {
                name, description
              }
            },
            TaxPaymentModesEnum:__type(name:"TaxPaymentModesEnum") {
              enumValues {
                name, description
              }
            },
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          commit('setEnums', results);
        }
      } catch (e) {
        dispatch('flashError', 'There was a problem caching data (enums).', { root: true });
      }
    },
  },
  getters: {
  },
};
export default enums;
